<template>
  <span :aria-hidden="decorative" class="material-design-icon sync-icon" role="img">
    <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" viewBox="0 0 24 24" :fill="fill">
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <g />
        <g>
          <path d="M22,8l-4-4v3H3v2h15v3L22,8z" />
          <path d="M2,16l4,4v-3h15v-2H6v-3L2,16z" />
        </g>
      </g>
    </svg>
  </span>
</template>
<script lang="ts" setup>
defineProps({
  fill: {
    type: String,
    default: 'currentColor',
  },
});

defineOptions({
  name: 'n-custom-attribute-icon',
});
</script>
